import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

type SituationStringEnum = "remote" | "face-to-face";

export default class TherapeuticAssistanceSessionCompletedJournalEvent extends JournalEvent {
  static override type =
    "therapeutic-assistance-session-completed-journal-event";

  @attr("string") declare situation: SituationStringEnum;

  @attr("string") declare name: string;

  @attr("string") declare diagnostic: string;

  @attr("string") declare educationSubjects: string;

  @attr("string") declare patientQuestions: string;

  @attr("string") declare wrapUp: string;

  static override validations(intl: IntlService) {
    return {
      situation: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.therapeutic-assistance-session-completed-journal-event.situation"
          )
        }),
        validateInclusion({
          list: ["remote", "face-to-face"],
          description: intl.t(
            "validations.therapeutic-assistance-session-completed-journal-event.situation"
          )
        })
      ],
      name: validatePresence({
        presence: true,
        description: intl.t(
          "validations.therapeutic-assistance-session-completed-journal-event.name"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.therapeutic-assistance-session-completed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "therapeuticAssistanceSessionCompletedJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "therapeutic-assistance-session-completed-journal-event": TherapeuticAssistanceSessionCompletedJournalEvent;
  }
}
